import React, { Component } from 'react'
import styled from 'styled-components'
import Button from '../../common/Button'

const Container = styled.div`
  height: 260px;
  width: 400px;
  border-radius: 10px;
  background-color: #FFFFFF;
  box-shadow: 0 0 20px 0 rgba(57,57,58,0.2);
  justify-content: center;
  align-items: center;
`
const Title = styled.h3`
  height: 24px;
  color: #56565A;
  font-family: "Open Sans";
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  margin-top: 30px;
`
const Content = styled.div`
  color: #56565A;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 22px;
  text-align: center;
  margin-top: 20px;
`
const ButtonContainer = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
`
const Cancel = Button.extend`
  background: none;
  box-sizing: border-box;
  height: 35px;
  width: 75px;
  border: 1px solid rgba(57,57,58,0.2);
  border-radius: 4px;
  color: #39393A;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
  text-align: center;
  margin-right: 25px;
`
const Submit = Button.extend`
  background-color: #CC6900;
  box-sizing: border-box;
  height: 35px;
  width: 75px;
  border: 1px solid rgba(57,57,58,0.2);
  border-radius: 4px;
  color: #FFFFFF;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
  text-align: center;
  margin-right: 25px;
`

class APIConfirmationModal extends Component {
  render() {
    const { toggleModal, onSubmitClick } = this.props

    return (
      <Container>
        <Title>Send Loan Request to SBA for Review</Title>
        <Content>Upon a successful request, you’ll receive a confirmation number. The SBA will not provide a PLP number immediately, but will update the loan status when the request has been decisioned.</Content>
        <ButtonContainer>
          <Cancel onClick={toggleModal}>
            Cancel
          </Cancel>
          <Submit onClick={onSubmitClick}>
            Submit
          </Submit>
        </ButtonContainer>
      </Container>
    )
  }
}
export default APIConfirmationModal
